import api from './api';

export const getSettings = async () => {
  try {
    const response = await api.get('/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

export const updateSettings = async (data) => {
  try {
    const response = await api.put('/settings', data);
    return response.data;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw error;
  }
};

export const uploadLogo = async (file) => {
  try {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post('/settings/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading logo:', error);
    throw error;
  }
};

export const geocodeAddress = async (data = {}) => {
  const response = await api.post('/settings/geocode', data);
  return response.data;
};

export const deleteLogo = async () => {
  try {
    const response = await api.delete('/settings/logo');
    return response.data;
  } catch (error) {
    console.error('Error deleting logo:', error);
    throw error;
  }
};
